import { GBSCError } from "@/models/GBSCError";
import {
  IBookedByResponse,
  IDashboardResponse,
  IHospitalSummaryResponse,
} from "@/models/ApiRequestResponse/dashboard";

import { get } from "@/utils/TypedApi";

import {
  APIEndpoint,
  IAPIStatusCode,
  IAPIStatusType,
  messages,
} from "../APIEndpointConfig";

import { IDashboardQueryParams } from "@/models/dashboard";

export const getPatientsSummaryApi = async (
  queryParams: IDashboardQueryParams
): Promise<IDashboardResponse | GBSCError> => {
  try {
    let url = APIEndpoint.doctor.dashboard.patientsSummary;
    const queryParam = [
      queryParams.startDate && `startDate=${queryParams.startDate}`,
      queryParams.endDate && `endDate=${queryParams.endDate}`,
      queryParams.bookedBy && `bookedBy=${queryParams.bookedBy}`,
      queryParams.isExport && `export=${queryParams.isExport}`,
    ].filter(Boolean);

    const finalUrl = queryParam.length ? `${url}?${queryParam.join("&")}` : url;

    const response = await get<IDashboardResponse>(finalUrl);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getHospitalSummaryApi = async (
  queryParams: IDashboardQueryParams
): Promise<IHospitalSummaryResponse | GBSCError> => {
  try {
    let url = APIEndpoint.doctor.dashboard.hospitalSummary;
    const queryParam = [
      queryParams.startDate && `startDate=${queryParams.startDate}`,
      queryParams.endDate && `endDate=${queryParams.endDate}`,
      queryParams.hospitalId && `hospitalId=${queryParams.hospitalId}`,
    ].filter(Boolean);

    const finalUrl = queryParam.length ? `${url}?${queryParam.join("&")}` : url;

    const response = await get<IHospitalSummaryResponse>(finalUrl);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getCompletedConsultationSummaryApi = async (
  queryParams: IDashboardQueryParams
): Promise<any | GBSCError> => {
  try {
    let url = APIEndpoint.doctor.dashboard.completedConsultationSummary;
    const queryParam = [
      queryParams.startDate && `startDate=${queryParams.startDate}`,
      queryParams.endDate && `endDate=${queryParams.endDate}`,
      queryParams.bookedBy && `bookedBy=${queryParams.bookedBy}`,
      queryParams.isExport && `export=${queryParams.isExport}`,
    ].filter(Boolean);

    const finalUrl = queryParam.length ? `${url}?${queryParam.join("&")}` : url;

    const response = await get<any>(finalUrl);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getBookedByDetailApi = async (
  queryParams: IDashboardQueryParams
): Promise<IBookedByResponse | GBSCError> => {
  try {
    let url = APIEndpoint.doctor.dashboard.bookedBy;
    const finalUrl = `${url}&search=${queryParams.search}`;

    const response = await get<IBookedByResponse>(finalUrl);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};
